<div *ngIf="isError">
  <!-- [エラーヘッダー] -->
  <header class="l-biz-header">
    <div class="l-biz-header__main">
      <div class="l-wrap">
        <div class="l-wrap__inner">
          <div class="l-biz-header__wrap">
            <div class="l-biz-header__logo-area">
              <ng-container *ngIf="isShowAnaBiz; else imgViewNotLogin">
                <a
                  id="ana-biz-header-logo-ana-biz-not-login-isError"
                  (throttleClick$)="clickANABizLogoEvent()"
                  aswThrottleClick
                >
                  <img
                    src="{{
                      aswLangCode === 'en' ? 'assets/images/logo_ana_biz-en.svg' : 'assets/images/logo_ana_biz.svg'
                    }}"
                    alt="{{ 'alt.logoAnaBiz' | staticMsg }}"
                  />
                </a>
              </ng-container>
              <ng-template #imgViewNotLogin>
                <img
                  src="{{
                    aswLangCode === 'en' ? 'assets/images/logo_ana_biz-en.svg' : 'assets/images/logo_ana_biz.svg'
                  }}"
                />
              </ng-template>
            </div>
            <div class="l-biz-header__sub-area">
              <ul class="l-biz-header__sub-list u-display-flex-tb" [attr.inert]="this.isAnaBizMenuOpen ? true : null">
                <li class="l-biz-header__sub-item" *ngIf="this.isEnabledLogin">
                  <button
                    id="ana-biz-header-amc-login-button-isError"
                    class="c-btn-quaternary c-btn-quaternary--login"
                    (click)="clickAMCLoginEvent()"
                  >
                    <span class="c-btn-quaternary__text" [innerHTML]="'label.amcLogin' | staticMsg"></span>
                  </button>
                </li>
              </ul>
              <div class="l-biz-header__close u-display-block-sp">
                <button
                  id="ana-biz-header-open-button-not-login-menu-isError"
                  class="l-biz-header-non-member-drawer-close js-menu-btn"
                  [attr.aria-label]="'alt.hamburgerMemu' | staticMsg"
                  aria-controls="drawer-menu"
                  aria-expanded="false"
                  (click)="clickMenuSpEvent()"
                >
                  <span></span><span></span><span></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="this.isBizHeader">
      <div class="l-biz-header__block u-display-block-tb">
        <div class="l-wrap">
          <div class="l-wrap__inner">
            <div class="l-biz-header__wrap">
              <div class="l-biz-header__sub-area">
                <ul class="l-biz-header__sub-list u-display-flex-tb">
                  <li
                    class="l-biz-header__sub-item"
                    *ngIf="isShowAnaBiz"
                    [innerHTML]="'label.topPage' | staticMsg"
                  ></li>
                  <li class="l-biz-header__sub-item" [innerHTML]="'label.contactByEmail' | staticMsg"></li>
                  <li class="l-biz-header__sub-item" [innerHTML]="'label.contactByPhone' | staticMsg"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- [ログイン前メニュー] -->
    <div id="drawer-menu" class="l-biz-header-drawer u-display-block-sp" aria-hidden="false">
      <div class="l-biz-header-drawer__inner">
        <nav class="l-biz-header-drawer__body">
          <div class="l-biz-header-drawer__menu-area" tabindex="0">
            <div class="p-drawer-menu-non-member" [attr.inert]="!this.isAnaBizMenuOpen ? true : null">
              <ng-container *ngIf="!this.isAnaBizLogin">
                <div class="p-drawer-menu-non-member__block">
                  <ul class="p-drawer-menu-non-member__list"></ul>
                </div>
              </ng-container>
              <div class="p-drawer-menu-non-member__btn-area">
                <ul class="p-drawer-menu-non-member__info">
                  <li class="p-drawer-menu-non-member__info-item" *ngIf="isShowAnaBiz">
                    <a
                      id="ana-biz-header-top-page-not-login-menu-isError"
                      href="/"
                      class="p-drawer-menu-non-member__info-link"
                      tabindex="0"
                      [innerHTML]="'label.topPage' | staticMsg"
                      aswThrottleClick
                      (throttleClick$)="onClickTopPageUrl($event)"
                    ></a>
                  </li>
                  <li class="p-drawer-menu-non-member__info-item" [innerHTML]="'label.contactByEmail' | staticMsg"></li>
                  <li class="p-drawer-menu-non-member__info-item" [innerHTML]="'label.contactByPhone' | staticMsg"></li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="l-biz-header-drawer__bg"></div>
    </div>
  </header>
  <!-- //[エラーヘッダー] -->
</div>

<div *ngIf="!isError">
  <div *ngIf="this.isNotLogin">
    <!-- [ログイン前ヘッダー] -->
    <header class="l-biz-header">
      <div class="l-biz-header__main">
        <div class="l-wrap">
          <div class="l-wrap__inner">
            <div class="l-biz-header__wrap">
              <div class="l-biz-header__logo-area">
                <ng-container *ngIf="isShowAnaBiz; else imgViewNotLogin">
                  <a
                    id="ana-biz-header-logo-ana-biz-not-login"
                    (throttleClick$)="clickANABizLogoEvent()"
                    aswThrottleClick
                  >
                    <img
                      src="{{
                        aswLangCode === 'en' ? 'assets/images/logo_ana_biz-en.svg' : 'assets/images/logo_ana_biz.svg'
                      }}"
                      alt="{{ 'alt.logoAnaBiz' | staticMsg }}"
                    />
                  </a>
                </ng-container>
                <ng-template #imgViewNotLogin>
                  <img
                    src="{{
                      aswLangCode === 'en' ? 'assets/images/logo_ana_biz-en.svg' : 'assets/images/logo_ana_biz.svg'
                    }}"
                  />
                </ng-template>
              </div>
              <div class="l-biz-header__sub-area">
                <ul class="l-biz-header__sub-list u-display-flex-tb" [attr.inert]="this.isAnaBizMenuOpen ? true : null">
                  <li class="l-biz-header__sub-item" *ngIf="this.isEnabledLogin">
                    <button
                      id="ana-biz-header-amc-login-button"
                      class="c-btn-quaternary c-btn-quaternary--login"
                      (click)="clickAMCLoginEvent()"
                    >
                      <span class="c-btn-quaternary__text" [innerHTML]="'label.amcLogin' | staticMsg"></span>
                    </button>
                  </li>
                </ul>
                <div class="l-biz-header__close u-display-block-sp">
                  <button
                    id="ana-biz-header-open-button-not-login-menu"
                    class="l-biz-header-non-member-drawer-close js-menu-btn"
                    [attr.aria-label]="'alt.hamburgerMemu' | staticMsg"
                    aria-controls="drawer-menu"
                    aria-expanded="false"
                    (click)="clickMenuSpEvent()"
                  >
                    <span></span><span></span><span></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="this.isBizHeader">
        <div class="l-biz-header__block u-display-block-tb">
          <div class="l-wrap">
            <div class="l-wrap__inner">
              <div class="l-biz-header__wrap">
                <div class="l-biz-header__sub-area">
                  <ul class="l-biz-header__sub-list u-display-flex-tb">
                    <li
                      class="l-biz-header__sub-item"
                      *ngIf="isShowAnaBiz"
                      [innerHTML]="'label.topPage' | staticMsg"
                    ></li>
                    <li class="l-biz-header__sub-item">
                      <a
                        id="ana-biz-header-biz-plan-list-link-not-login"
                        [href]="planlistUrl | headerUrl"
                        class="c-text-link"
                        [innerHTML]="'label.planList' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickPlanListUrl($event)"
                      ></a>
                    </li>
                    <li class="l-biz-header__sub-item">
                      <a
                        id="ana-biz-header-biz-booking-search-link-not-login"
                        [href]="bookingSearchUrl | headerUrl"
                        class="c-text-link"
                        [innerHTML]="'label.reservationSearch' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickBoolingSearchUrl($event)"
                      ></a>
                    </li>
                    <li class="l-biz-header__sub-item" [innerHTML]="'label.contactByEmail' | staticMsg"></li>
                    <li class="l-biz-header__sub-item" [innerHTML]="'label.contactByPhone' | staticMsg"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="l-biz-header__block">
        <div class="l-wrap">
          <div class="l-wrap__inner">
            <div class="l-biz-header__wrap" *ngIf="this.isAnaBizLogin">
              <div class="l-biz-header__company-area">
                <span class="l-biz-header__company-main">{{
                  aswLangCode === 'en' && anaBizContextAuthInfoData?.companyInfoA?.companyNameEn
                    ? anaBizContextAuthInfoData?.companyInfoA?.companyNameEn
                    : anaBizContextAuthInfoData?.companyInfoA?.companyName
                }}</span>
                <span class="l-biz-header__company-sub">{{
                  aswLangCode === 'en' && anaBizContextAuthInfoData?.companyInfoC?.contractSecNameEn
                    ? anaBizContextAuthInfoData?.companyInfoC?.contractSecNameEn
                    : anaBizContextAuthInfoData?.companyInfoC?.contractSecName
                }}</span>
              </div>
              <div class="l-biz-header__sub-area">
                <ul class="l-biz-header__sub-list u-display-flex-tb">
                  <li class="l-biz-header__sub-item">
                    <button
                      id="ana-biz-header-amc-logout-button-not-login"
                      class="c-btn-secondary c-btn-secondary--xs"
                      (throttleClick$)="clickANABizLogoutEvent()"
                      aswThrottleClick
                    >
                      <span class="c-btn-secondary__text" [innerHTML]="'label.anaBizLogout' | staticMsg"></span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- [ログイン前メニュー] -->
      <div id="drawer-menu" class="l-biz-header-drawer u-display-block-sp" aria-hidden="false">
        <div class="l-biz-header-drawer__inner">
          <nav class="l-biz-header-drawer__body">
            <div class="l-biz-header-drawer__menu-area" tabindex="0">
              <div class="p-drawer-menu-non-member" [attr.inert]="!this.isAnaBizMenuOpen ? true : null">
                <div class="p-drawer-menu-non-member__block" *ngIf="this.isAnaBizLogin">
                  <div class="p-drawer-menu-non-member__company">
                    <div class="p-drawer-menu-non-member__company-label">
                      <span class="p-drawer-menu-non-member__company-label-main">{{
                        aswLangCode === 'en' && anaBizContextAuthInfoData?.companyInfoA?.companyNameEn
                          ? anaBizContextAuthInfoData?.companyInfoA?.companyNameEn
                          : anaBizContextAuthInfoData?.companyInfoA?.companyName
                      }}</span>
                      <span class="p-drawer-menu-non-member__company-label-sub">{{
                        aswLangCode === 'en' && anaBizContextAuthInfoData?.companyInfoC?.contractSecNameEn
                          ? anaBizContextAuthInfoData?.companyInfoC?.contractSecNameEn
                          : anaBizContextAuthInfoData?.companyInfoC?.contractSecName
                      }}</span>
                    </div>
                    <div class="p-drawer-menu-non-member__company-btn">
                      <button
                        id="ana-biz-header-ana-biz-logout-button-not-login-menu"
                        class="c-btn-secondary c-btn-secondary--xs"
                        tabindex="0"
                        (throttleClick$)="clickANABizLogoutEvent()"
                        aswThrottleClick
                      >
                        <span class="c-btn-secondary__text" [innerHTML]="'label.anaBizLogout' | staticMsg"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="p-drawer-menu-non-member__block">
                  <ul class="p-drawer-menu-non-member__list">
                    <li class="p-drawer-menu-non-member__item">
                      <a
                        id="ana-biz-header-biz-plan-list-link-not-login-menu"
                        [href]="planlistUrl | headerUrl"
                        class="p-drawer-menu-non-member__link"
                        tabindex="-1"
                        [innerHTML]="'label.planList' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickPlanListUrl($event)"
                      ></a>
                    </li>
                    <li class="p-drawer-menu-non-member__item">
                      <a
                        id="ana-biz-header-biz-booking-search-link-not-login-menu"
                        [href]="bookingSearchUrl | headerUrl"
                        class="p-drawer-menu-non-member__link"
                        tabindex="-1"
                        [innerHTML]="'label.reservationSearch' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickBoolingSearchUrl($event)"
                      ></a>
                    </li>
                  </ul>
                </div>
                <div class="p-drawer-menu-non-member__btn-area">
                  <ul class="p-drawer-menu-non-member__info">
                    <li class="p-drawer-menu-non-member__info-item" *ngIf="isShowAnaBiz">
                      <a
                        id="ana-biz-header-top-page-not-login-menu"
                        href="/"
                        class="p-drawer-menu-non-member__info-link"
                        tabindex="0"
                        [innerHTML]="'label.topPage' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickTopPageUrl($event)"
                      ></a>
                    </li>
                    <li
                      class="p-drawer-menu-non-member__info-item"
                      [innerHTML]="'label.contactByEmail' | staticMsg"
                    ></li>
                    <li
                      class="p-drawer-menu-non-member__info-item"
                      [innerHTML]="'label.contactByPhone' | staticMsg"
                    ></li>
                  </ul>
                  <div class="p-drawer-menu-non-member__logout" *ngIf="this.isEnabledLogin">
                    <button
                      id="ana-biz-header-amc-login-button-not-login-menu"
                      class="c-btn-primary c-btn-primary--xs"
                      tabindex="-1"
                      (click)="clickAMCLoginEvent()"
                    >
                      <span class="c-btn-primary__text" [innerHTML]="'label.amcLogin' | staticMsg"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
        <div class="l-biz-header-drawer__bg"></div>
      </div>
      <!-- //[ログイン前メニュー] -->
    </header>
    <!-- //[ログイン前ヘッダー] -->
  </div>

  <div *ngIf="!this.isNotLogin">
    <!-- [ログイン後ヘッダー] -->
    <header class="l-biz-header">
      <div class="l-biz-header__main">
        <div class="l-wrap">
          <div class="l-wrap__inner">
            <div class="l-biz-header__wrap">
              <div class="l-biz-header__logo-area">
                <ng-container *ngIf="isShowAnaBiz; else imgViewLogin">
                  <a id="ana-biz-header-logo-ana-biz-login" (click)="clickANABizLogoEvent()">
                    <img
                      src="{{
                        aswLangCode === 'en' ? 'assets/images/logo_ana_biz-en.svg' : 'assets/images/logo_ana_biz.svg'
                      }}"
                      alt="{{ 'alt.anaBiz' | staticMsg }}"
                    />
                  </a>
                </ng-container>
                <ng-template #imgViewLogin>
                  <img
                    src="{{
                      aswLangCode === 'en' ? 'assets/images/logo_ana_biz-en.svg' : 'assets/images/logo_ana_biz.svg'
                    }}"
                  />
                </ng-template>
              </div>
              <div class="l-biz-header__sub-area">
                <ul class="l-biz-header__sub-list">
                  <li class="l-biz-header__sub-item">
                    <button
                      id="ana-biz-header-open-button-login"
                      class="l-biz-header__user js-menu-btn"
                      [attr.aria-label]="'alt.hamburgerMemu' | staticMsg"
                      aria-controls="drawer-menu"
                      aria-expanded="false"
                      (click)="openMenuEvent()"
                    >
                      <span
                        class="l-biz-header__user-name"
                        [innerHTML]="
                          _headerService.getLetrName()
                            | staticMsg
                              : {
                                  '0': _common.amcMemberStoreService.amcMemberData.letterName
                                    ? _common.amcMemberStoreService.amcMemberData.letterName.replace('　', ' ') || ''
                                    : ''
                                }
                        "
                      ></span>
                    </button>
                  </li>
                  <li
                    class="l-header__sub-item u-display-block-tb"
                    [innerHTML]="
                      'label.mileage'
                        | staticMsg
                          : {
                              '0': amcMemberData.mileBalance ?? 0 | numberFormat : ('label.mileageFormat' | staticMsg)
                            }
                    "
                  ></li>
                </ul>
                <div class="l-biz-header__close">
                  <button
                    id="ana-biz-header-close-button-login"
                    class="l-biz-header-member-drawer-close js-menu-btn"
                    aria-controls="drawer-menu"
                    aria-expanded="false"
                    (click)="closeMenuEvent()"
                  >
                    <span class="u-visually-hidden">Close Menu</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="this.isBizHeader">
        <div class="l-biz-header__block u-display-block-tb">
          <div class="l-wrap">
            <div class="l-wrap__inner">
              <div class="l-biz-header__wrap">
                <div class="l-biz-header__sub-area">
                  <ul class="l-biz-header__sub-list u-display-flex-tb">
                    <li class="l-biz-header__sub-item" *ngIf="isShowAnaBiz">
                      <a
                        id="ana-biz-header-top-page-login"
                        href="/"
                        class="c-text-link"
                        [innerHTML]="'label.topPage' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickTopPageUrl($event)"
                      ></a>
                    </li>
                    <li class="l-biz-header__sub-item">
                      <a
                        id="ana-biz-header-biz-plan-list-link-login"
                        [href]="planlistUrl | headerUrl"
                        class="c-text-link"
                        [innerHTML]="'label.planList' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickPlanListUrl($event)"
                      ></a>
                    </li>
                    <li class="l-biz-header__sub-item">
                      <a
                        id="ana-biz-header-biz-booking-search-link-login"
                        [href]="bookingSearchUrl | headerUrl"
                        class="c-text-link"
                        [innerHTML]="'label.reservationSearch' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickBoolingSearchUrl($event)"
                      ></a>
                    </li>
                    <li class="l-biz-header__sub-item" [innerHTML]="'label.contactByEmail' | staticMsg"></li>
                    <li class="l-biz-header__sub-item" [innerHTML]="'label.contactByPhone' | staticMsg"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="l-biz-header__block">
        <div class="l-wrap">
          <div class="l-wrap__inner">
            <div class="l-biz-header__wrap" *ngIf="this.isAnaBizLogin">
              <div class="l-biz-header__company-area">
                <span class="l-biz-header__company-main">{{
                  aswLangCode === 'en' && anaBizContextAuthInfoData?.companyInfoA?.companyNameEn
                    ? anaBizContextAuthInfoData?.companyInfoA?.companyNameEn
                    : anaBizContextAuthInfoData?.companyInfoA?.companyName
                }}</span>
                <span class="l-biz-header__company-sub">{{
                  aswLangCode === 'en' && anaBizContextAuthInfoData?.companyInfoC?.contractSecNameEn
                    ? anaBizContextAuthInfoData?.companyInfoC?.contractSecNameEn
                    : anaBizContextAuthInfoData?.companyInfoC?.contractSecName
                }}</span>
              </div>
              <div class="l-biz-header__sub-area">
                <ul class="l-biz-header__sub-list u-display-flex-tb">
                  <li class="l-biz-header__sub-item">
                    <button
                      id="ana-biz-header-amc-logout-button-login"
                      class="c-btn-secondary c-btn-secondary--xs"
                      (throttleClick$)="clickANABizLogoutEvent()"
                      aswThrottleClick
                    >
                      <span class="c-btn-secondary__text" [innerHTML]="'label.anaBizLogout' | staticMsg"></span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- [ログイン後メニュー] -->
      <div id="drawer-menu" class="l-biz-header-drawer" aria-hidden="false">
        <div class="l-biz-header-drawer__inner">
          <nav class="l-biz-header-drawer__body">
            <div class="l-biz-header-drawer__menu-area" tabindex="0">
              <div class="p-drawer-menu-member" [attr.inert]="!this.isAnaBizMenuOpen ? true : null">
                <div class="p-drawer-menu-member__block" *ngIf="this.isAnaBizLogin">
                  <div class="p-drawer-menu-member__company">
                    <div class="p-drawer-menu-member__company-label">
                      <span class="p-drawer-menu-member__company-label-main">{{
                        aswLangCode === 'en' && anaBizContextAuthInfoData?.companyInfoA?.companyNameEn
                          ? anaBizContextAuthInfoData?.companyInfoA?.companyNameEn
                          : anaBizContextAuthInfoData?.companyInfoA?.companyName
                      }}</span>
                      <span class="p-drawer-menu-member__company-label-sub">{{
                        aswLangCode === 'en' && anaBizContextAuthInfoData?.companyInfoC?.contractSecNameEn
                          ? anaBizContextAuthInfoData?.companyInfoC?.contractSecNameEn
                          : anaBizContextAuthInfoData?.companyInfoC?.contractSecName
                      }}</span>
                    </div>
                    <div class="p-drawer-menu-member__company-btn">
                      <button
                        id="ana-biz-header-ana-biz-logout-button-login-menu"
                        class="c-btn-secondary c-btn-secondary--xs"
                        tabindex="0"
                        (throttleClick$)="clickANABizLogoutEvent()"
                        aswThrottleClick
                      >
                        <span class="c-btn-secondary__text" [innerHTML]="'label.anaBizLogout' | staticMsg"></span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="p-drawer-menu-member__block">
                  <div class="p-drawer-menu-member__item">
                    <div class="p-drawer-menu-member__name">
                      <span class="p-drawer-menu-member__name-status">
                        <img
                          [src]="_headerService.getMemberImage()"
                          width="50"
                          height="29"
                          [alt]="_headerService.getMemberAlt() | staticMsg"
                        />
                      </span>
                      <div
                        [innerHTML]="
                          _headerService.getLetrName()
                            | staticMsg
                              : { '0': amcMemberData.letterName ? amcMemberData.letterName.replace('　', ' ') : '' }
                        "
                      ></div>
                    </div>
                  </div>
                  <dl class="p-drawer-menu-member__def">
                    <div class="p-drawer-menu-member__item">
                      <dt
                        class="p-drawer-menu-member__item-heading p-drawer-menu-member__item-heading--gray70"
                        [innerHTML]="'label.mileage1' | staticMsg"
                      ></dt>
                      <dd
                        class="p-drawer-menu-member__item-body"
                        [innerHTML]="
                          'label.mileage'
                            | staticMsg
                              : {
                                  '0':
                                    amcMemberData.mileBalance ?? 0 | numberFormat : ('label.mileageFormat' | staticMsg)
                                }
                        "
                      ></dd>
                    </div>
                    <div class="p-drawer-menu-member__item">
                      <dt
                        class="p-drawer-menu-member__item-heading p-drawer-menu-member__item-heading--gray70"
                        [innerHTML]="'label.anaSkyCoin' | staticMsg"
                      ></dt>
                      <dd class="p-drawer-menu-member__item-body">
                        <span
                          class="p-drawer-menu-member__unit"
                          [innerHTML]="
                            'label.anaSkyCoins'
                              | staticMsg
                                : {
                                    '0':
                                      amcMemberData.skyCoinBalance ?? 0
                                      | numberFormat : ('label.anaSkyCoinsFormat' | staticMsg)
                                  }
                          "
                        ></span>
                      </dd>
                    </div>
                    <div class="p-drawer-menu-member__item">
                      <dt
                        class="p-drawer-menu-member__item-heading p-drawer-menu-member__item-heading--gray70"
                        [innerHTML]="
                          ('label.premiumPoint' | staticMsg) +
                          ('label.spaceSeparator' | staticMsg) +
                          ('label.pointOnAna' | staticMsg)
                        "
                      ></dt>
                      <dd class="p-drawer-menu-member__item-body">
                        <span
                          [innerHTML]="
                            'label.premiumPoints'
                              | staticMsg
                                : {
                                    '0':
                                      amcMemberData.premiumPointTotal ?? 0
                                      | numberFormat : ('label.premiumPointsFormat' | staticMsg)
                                  }
                          "
                        ></span>
                        <span [innerHTML]="'label.spaceSeparator' | staticMsg"></span>
                        <span
                          [innerHTML]="
                            'label.premiumPoints'
                              | staticMsg
                                : {
                                    '0':
                                      amcMemberData.premiumPointAnaTotal ?? 0
                                      | numberFormat : ('label.premiumPointsFormat' | staticMsg)
                                  }
                          "
                        ></span>
                      </dd>
                    </div>
                    <div
                      *ngIf="
                        amcMemberData.upgradePointBalanceThisYear !== null &&
                        amcMemberData.upgradePointBalanceThisYear !== undefined
                      "
                      class="p-drawer-menu-member__item"
                    >
                      <dt
                        class="p-drawer-menu-member__item-heading p-drawer-menu-member__item-heading--gray70"
                        [innerHTML]="'label.upgradePoint' | staticMsg"
                      ></dt>
                      <dd class="p-drawer-menu-member__item-body">
                        <span
                          class="p-drawer-menu-member__unit"
                          [innerHTML]="
                            'label.upbgradePoints'
                              | staticMsg
                                : {
                                    '0':
                                      amcMemberData.upgradePointBalanceThisYear
                                      | numberFormat : ('label.upbgradePointsFormat' | staticMsg)
                                  }
                          "
                        ></span>
                      </dd>
                    </div>
                  </dl>
                  <ul class="p-drawer-menu-member__list">
                    <li class="p-drawer-menu-member__company">
                      <span class="p-drawer-menu-member__link-wrap">
                        <span class="p-drawer-menu-member__link-label" [innerHTML]="'label.useMiles' | staticMsg">
                        </span>
                      </span>
                    </li>
                    <li class="p-drawer-menu-member__item"></li>
                    <li class="p-drawer-menu-member__company">
                      <span class="p-drawer-menu-member__link-wrap">
                        <span class="p-drawer-menu-member__link-label" [innerHTML]="'label.earnMiles' | staticMsg">
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
                <div class="p-drawer-menu-member__block">
                  <ul class="p-drawer-menu-member__list">
                    <li class="p-drawer-menu-member__item">
                      <a
                        id="ana-biz-header-biz-plan-list-link-login-menu"
                        [href]="planlistUrl | headerUrl"
                        class="p-drawer-menu-member__link"
                        tabindex="0"
                        aswThrottleClick
                        (throttleClick$)="onClickPlanListUrl($event)"
                      >
                        <span class="p-drawer-menu-member__link-wrap">
                          <span
                            class="p-drawer-menu-member__link-label p-drawer-menu-member__link-label--em"
                            [innerHTML]="'label.planList' | staticMsg"
                          ></span>
                        </span>
                      </a>
                    </li>
                    <li class="p-drawer-menu-member__item">
                      <a
                        id="ana-biz-header-biz-booking-search-link-login-menu"
                        [href]="bookingSearchUrl | headerUrl"
                        class="p-drawer-menu-member__link"
                        tabindex="0"
                        aswThrottleClick
                        (throttleClick$)="onClickBoolingSearchUrl($event)"
                      >
                        <span class="p-drawer-menu-member__link-wrap">
                          <span
                            class="p-drawer-menu-member__link-label p-drawer-menu-member__link-label--em"
                            [innerHTML]="'label.reservationSearch' | staticMsg"
                          ></span>
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="p-drawer-menu-member__btn-area">
                  <ul class="p-drawer-menu-member__info">
                    <li class="p-drawer-menu-member__info-item" *ngIf="isShowAnaBiz">
                      <a
                        id="ana-biz-header-top-page-login-menu"
                        href="/"
                        class="p-drawer-menu-member__info-link"
                        tabindex="0"
                        [innerHTML]="'label.topPage' | staticMsg"
                        (throttleClick$)="onClickTopPageUrl($event)"
                      ></a>
                    </li>
                    <li
                      class="p-drawer-menu-non-member__info-item"
                      [innerHTML]="'label.contactByEmail' | staticMsg"
                    ></li>
                    <li
                      class="p-drawer-menu-non-member__info-item"
                      [innerHTML]="'label.contactByPhone' | staticMsg"
                    ></li>
                  </ul>
                  <div class="p-drawer-menu-member__logout">
                    <button
                      id="ana-biz-header-amc-logout-button-login-menu"
                      class="c-btn-secondary c-btn-secondary--xs"
                      tabindex="-1"
                      (click)="clickAMCLogoutEvent()"
                    >
                      <span class="c-btn-secondary__text" [innerHTML]="'label.amcLogout' | staticMsg"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
        <div class="l-biz-header-drawer__bg"></div>
      </div>
      <!-- //[ログイン後メニュー] -->
    </header>
    <!-- //[ログイン後ヘッダー] -->
  </div>
</div>
